import React from 'react';
import classNames from 'classnames';
import { PropType } from './types';

export const ToggleButton = ({
	label,
	isActive,
	onClick,
}: {
	label: string;
	isActive: boolean;
	onClick: () => void;
}) => (
	<button
		className={classNames(
			'px-3 py-1 border min-w-20 border-[#262b30] leading-normal hover:bg-gray-200 hover:text-[#324B69]',
			{ 'bg-[#324B69] text-white': isActive }
		)}
		onClick={onClick}
	>
		{label}
	</button>
);

export const Button: React.FC<PropType> = ({
	title,
	onPress,
	styleDiv,
	styleSpan,
}) => {
	return (
		<div className={`${styleDiv}`} onClick={onPress}>
			<span className={`${styleSpan}`}>{title}</span>
		</div>
	);
};
